/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Filter_UncountedInputs */

const vi_stocktake_filter_uncounted = /** @type {(inputs: Stocktake_Filter_UncountedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa kiểm`)
};

/**

* @param {Stocktake_Filter_UncountedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_filter_uncounted = /** @type {((inputs?: Stocktake_Filter_UncountedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Filter_UncountedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_filter_uncounted(inputs)
});